<p class="logo"><a routerLink="/"><img src="assets/images/logo-big.png" alt=""></a></p>
<div class="extract-box">
  <button class="btn-signout" (click)="signOut()">Sign Out</button>
  <div class="ctent-extract">
    <p class="tit-extract">Select datasets</p>
    <form>
      <div class="clearfix">
        <div class="enter-box">
          <fieldset>
            <legend><label><input type="radio" name="extract" value="0" checked="checked" (change)="changeExtract()">Enter specific datasets</label></legend>
            <div class="dtset">
              <textarea id="ids" placeholder="634, 23, 911, 1010, 891"></textarea>
              <p *ngIf="checkIds" class="error-require">{{ messageIds }}</p>
            </div>
          </fieldset>
          <fieldset>
            <legend><label><input type="radio" name="extract" value="1" (change)="changeExtract()">Enter range</label></legend>
            <div class="range">
              <div>
                <label class="clearfix">
                  Start ID: 
                  <span class="g-ip">
                    <input type="text" id="startid" name="startid" disabled="disabled" (keypress)="isNumberKey($event)">
                    <span *ngIf="checkStartId" class="error-require">{{ messageStartId }}</span>
                  </span>
                </label>
              </div>
              <div>
                <label class="clearfix">
                  Last ID: 
                  <span class="g-ip">
                    <input type="text" id="lastid" name="lastid" disabled="disabled" (keypress)="isNumberKey($event)">
                    <span *ngIf="checkLastId" class="error-require">{{ messageLastId }}</span>
                  </span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="button-box">
          <fieldset>
            <legend><label><input type="radio" name="extract" value="2" (change)="changeExtract()">Custom extraction</label></legend>
            <div class="custom">
              <button class="btn-extract" (click)="exCustom('devices')">Device Extraction</button>
              <button class="btn-extract" (click)="exCustom('ambassadors')">Monthly list ambassadors Extraction</button>
              <button class="btn-extract" (click)="exCustom('emails')">Email Address Extraction</button>
              <button class="btn-extract" (click)="exCustom('feedbacks')">Feedback Extraction</button>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="but-form">
        <button class="btn-form" (click)="handle('delete')">Delete</button>
        <button class="btn-form" (click)="handle('extract')">Extract</button>
      </div>
    </form>
  </div>
</div>
<div *ngIf="isConfirm" class="popup">
  <div class="confirm-box">
    <p class="tit-confirm">Alert</p>
    <p class="txt-confirm">{{ txtConfirm }}</p>
    <p class="bt-confirm">
      <span (click)="noDelete()">No</span>
      <span (click)="yesDelete()">Yes</span>
    </p>
  </div>
</div>
<div *ngIf="isCompleted" class="popup">
  <div class="confirm-box">
    <p class="tit-confirm">Alert</p>
    <p class="txt-confirm">{{ txtCompleted }}</p>
    <p class="bt-confirm">
      <span (click)="okAction()">OK</span>
    </p>
  </div>
</div>
<div *ngIf="isDownload && complete" class="popup">
  <div *ngIf="complete" class="link-box">
    <div class="item-link">
      CSV file:<br>
      <a [href]="csvLink" [download]="csvName">download link</a>
    </div>
    <div *ngIf="isData" class="item-link">
      Audios file:<br>
      <a [href]="audioLink" [download]="audioName">download link</a>
    </div>
    <div *ngIf="isData" class="item-link">
      Images file:<br>
      <a [href]="imageLink" [download]="imageName">download link</a>
    </div>
    <p class="bt-close">
      <span (click)="closePopup()">Close</span>
    </p>
  </div>
</div>
<div *ngIf="!complete" class="popup">
  <div class="sk-circle">
    <div class="sk-circle1 sk-child"></div>
    <div class="sk-circle2 sk-child"></div>
    <div class="sk-circle3 sk-child"></div>
    <div class="sk-circle4 sk-child"></div>
    <div class="sk-circle5 sk-child"></div>
    <div class="sk-circle6 sk-child"></div>
    <div class="sk-circle7 sk-child"></div>
    <div class="sk-circle8 sk-child"></div>
    <div class="sk-circle9 sk-child"></div>
    <div class="sk-circle10 sk-child"></div>
    <div class="sk-circle11 sk-child"></div>
    <div class="sk-circle12 sk-child"></div>
  </div>
</div>